import { Line } from "three";
// import "../styles/reset.css";
import "../styles/style.css";
import "../styles/book.css";

const sliderImages = document.querySelector(".slideshow_container.images");
const sliderRemote = document.querySelector(".slideshow_container.remote");
const progressbar = document.querySelector(".progressbar");
const progressdotsContainer = document.querySelector(".progressdot_container");

const blob_image = document.querySelector(".blob_image");
const nbImages = sliderImages.children[0].childNodes.length;

let toggleCursor = false;
let holding = false;
let clickNav = false;
let firstClickX;
let alreadyLeftScrolled;
let velocity;
let rafID;

const paralax = document.querySelectorAll(".paralax");
const lineTop = document.querySelector(".line");

function createLine(posTop, posLeft) {
  const div = document.createElement("div");
  div.style.height = posTop + "px";
  div.style.left = posLeft + "px";
  lineTop.appendChild(div);
}

for (let i = 0; i < paralax.length; i++) {
  const posTop =
    paralax[i].getBoundingClientRect().top + document.documentElement.scrollTop;
  const posLeft = paralax[i].getBoundingClientRect().left;
  const posZ = paralax[i].dataset.paralax;

  paralax[i].style.zIndex = posZ;

  createLine(posTop, posLeft);
}

document.addEventListener("scroll", () => {
  // updateTranslStripe();
  blob_image.style.transform = `translateY(${Math.round(window.scrollY) / 3
    }px)`;
  // blob_image.style.top = `${Math.round(window.scrollY)/3}px`;

  for (let i = 0; i < paralax.length; i++) {
    const posZ = paralax[i].dataset.paralax * -1;
    const posTop =
      paralax[i].getBoundingClientRect().top +
      document.documentElement.scrollTop / 2;

    paralax[i].style.transform = `translateY(${Math.round(window.scrollY - posTop) / posZ
      }px)`;
  }
});

//////// Book section ///////

const bbItem = document.querySelectorAll(".bb-item");
const bbProgressBar = document.querySelector(".book_progress");
bbProgressBar.style.background = "#000000";
bbProgressBar.style.width = 100 / (bbItem.length - 1);
// console.log(bbProgressBar);
// console.log(bbItem.length);

console.log(bbItem.length);
// window.addEventListener("click", () => {
//   let bbItemLength = bbItem.length;
//   let bbItemLengthMinus = bbItemLength - 1;
//   console.log(bbItemLengthMinus);
//   for (let i = bbItem.length; i >= bbItem.length - 1; i--) {
//     let i = (bbItem.length - i) * 10;
//     bbItem.length = bbItem.length - 1;
//     console.log(i);
//     bbProgressBar.style.width = bbProgressBarProgress + "(%)";
//     // console.log(bbItemLenghtMinus);
//     // console.log(i);
//   }
// });
const navLi = document.querySelectorAll(".links > li");

for (let i = 0; i < navLi.length; i++) {
  navLi[i].addEventListener("click", () => {
    clickNav = true;
    for (let j = 0; j < navLi.length; j++) {
      navLi[j].classList.remove("active");
    }
    navLi[i].classList.add("active");
    setTimeout(() => {
      clickNav = false;
    }, 600);
  });
}

////////// DRAG BLOC //////////

function dotModifier() {
  for (let i = 0; i < progressdotsContainer.classList.length; i++) {
    const element = progressdotsContainer.classList[i];
    if (element.search("divide") === 0) {
      // console.log(element.slice("divide".length));
      // return element.slice("divide".length)
      return 3;
    }
  }
}

if (sliderRemote) {
  for (let i = 0; i < nbImages; i++) {
    const divSlide = document.createElement("div");
    divSlide.classList.add("slide");
    sliderRemote.children[0].appendChild(divSlide);

    if (i % dotModifier() === 0) {
      const divDot = document.createElement("div");
      divDot.classList.add("progressdot");
      progressdotsContainer.appendChild(divDot);
    }
  }

  sliderRemote.addEventListener("mousedown", (e) => {
    holding = true;

    firstClickX = e.pageX - sliderRemote.offsetLeft;

    alreadyLeftScrolled = sliderRemote.scrollLeft;

    stopTransition();
  });

  sliderRemote.addEventListener("mousemove", (e) => {
    if (!holding) return;
    updateScrollbarWidth();
    const x = e.pageX - sliderRemote.offsetLeft;
    const scrolled = (x - firstClickX) * 1.5;
    const prevScrollLeft = sliderRemote.scrollLeft;

    sliderRemote.scrollLeft = alreadyLeftScrolled - scrolled;
    sliderImages.style.transform = `translateX(-${sliderRemote.scrollLeft}px)`;
    velocity = sliderRemote.scrollLeft - prevScrollLeft;
  });

  const progressdots = document.querySelectorAll(".progressdot");
  for (let i = 0; i < progressdots.length; i++) {
    progressdots[i].addEventListener("click", () => {
      const widthClick =
        ((i + 1) * sliderRemote.children[0].offsetWidth) / progressdots.length;

      sliderImages.style.transition = "all 0.2s ease";
      if (widthClick > sliderRemote.offsetWidth) {
        sliderRemote.scrollLeft = widthClick - sliderRemote.offsetWidth + 1;
        sliderImages.style.transform = `translateX(-${sliderRemote.scrollLeft}px)`;
      } else {
        sliderRemote.scrollLeft = 0;
        sliderImages.style.transform = `translateX(-${sliderRemote.scrollLeft}px)`;
      }
      setTimeout(() => {
        sliderImages.style.transition = "none";
      }, 200);

      updateScrollbarWidth();
    });
  }

  sliderRemote.addEventListener("mouseup", () => {
    holding = false;
    startTransition();
  });
  sliderRemote.addEventListener("mouseleave", () => {
    holding = false;
  });

  function startTransition() {
    stopTransition();
    rafID = requestAnimationFrame(decreasingTransition);
  }

  function stopTransition() {
    cancelAnimationFrame(rafID);
  }
  function decreasingTransition() {
    updateScrollbarWidth();
    sliderRemote.scrollLeft += velocity;
    sliderImages.style.transform = `translateX(-${sliderRemote.scrollLeft}px)`;
    velocity *= 0.95;
    if (Math.abs(velocity) > 0.5) {
      rafID = requestAnimationFrame(decreasingTransition);
    }
  }

  function updateScrollbarWidth() {
    let widthPercent =
      ((sliderRemote.scrollLeft + sliderRemote.offsetWidth) /
        sliderRemote.children[0].offsetWidth) *
      100;
    progressbar.style.width = widthPercent + "%";

    const steps = 100 / progressdots.length;
    const activeDot = widthPercent / steps;

    for (let i = 0; i < progressdots.length; i++) {
      if (i + 1 <= activeDot) {
        progressdots[i].classList.add("active");
      } else {
        progressdots[i].classList.remove("active");
      }
    }
  }

  updateScrollbarWidth();

  sliderRemote.addEventListener("touchstart", (e) => {
    holding = true;
    firstClickX = e.targetTouches[0].pageX - sliderRemote.offsetLeft;

    alreadyLeftScrolled = sliderRemote.scrollLeft;
    stopTransition();
  });
  sliderRemote.addEventListener("touchend", () => {
    holder = false;
    startTransition();
  });
  sliderRemote.addEventListener("touchmove", (e) => {
    if (!holding) return;
    updateScrollbarWidth();
    const x = e.targetTouches[0].pageX - sliderRemote.offsetLeft;
    const scrolled = (x - firstClickX) * 1.5;
    const prevScrollLeft = sliderRemote.scrollLeft;

    sliderRemote.scrollLeft = alreadyLeftScrolled - scrolled;
    sliderImages.style.transform = `translateX(-${sliderRemote.scrollLeft}px)`;
    velocity = sliderRemote.scrollLeft - prevScrollLeft;
  });
}

function vh(v) {
  var h = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  return (v * h) / 100;
}

let observer = new IntersectionObserver(
  function (observables) {
    observables.forEach(function (observable) {
      if (observable.intersectionRatio > 0.5 && !clickNav) {
        observable.target.classList.remove("not-visible");
        let scrollId = observable.target.querySelector("scroll-page").id;
        // observer.unobserve(observable.target)
        for (let j = 0; j < navLi.length; j++) {
          navLi[j].classList.remove("active");
        }
        navLi[scrollId - 1].classList.add("active");
      }
    });
  },
  {
    // rootMargin: vh(80) + "px",
    threshold: [0.6],
  }
);

let items = document.querySelectorAll(".main_page > section");
items.forEach(function (item) {
  item.classList.add("not-visible");
  observer.observe(item);
});

////////// CURSOR //////////

const cursor = document.querySelector(".cursor");

var timestamp = null;
var lastMouseX = null;
var lastMouseY = null;

let rafMouse;
let velocityMouse = 0;
let velocityMem = 0;

function decreasingMouse() {
  const oldRot = cursor.childNodes[0].style.transform.slice(7, -4) % 360;

  velocityMem *= 0.95;
  cursor.childNodes[0].style.transform = `rotate(${oldRot + Math.round(0.5 * velocityMem) / 10
    }deg)`;
  if (Math.abs(velocityMem) > 0.5) {
    rafMouse = requestAnimationFrame(decreasingMouse);
  }
}

document.body.addEventListener("mousemove", function (e) {
  cursor.style.left = `${e.clientX}px`;
  cursor.style.top = `${e.clientY}px`;

  if (timestamp === null) {
    timestamp = Date.now();
    lastMouseX = e.screenX;
    lastMouseY = e.screenY;
    return;
  }

  var now = Date.now();
  var dt = now - timestamp;
  var dx = e.screenX - lastMouseX;
  var dy = e.screenY - lastMouseY;
  var speedX = Math.round((dx / dt) * 100);
  var speedY = Math.round((dy / dt) * 100);

  timestamp = now;
  lastMouseX = e.screenX;
  lastMouseY = e.screenY;

  velocityMouse = Math.abs(speedX) + Math.abs(speedY);
  if (velocityMouse > velocityMem) {
    velocityMem = velocityMouse;
    cancelAnimationFrame(rafMouse);
    rafMouse = requestAnimationFrame(decreasingMouse);
  }
});

document.addEventListener("keypress", (e) => {
  if (e.code === "KeyC") {
    toggleCursor = !toggleCursor;
    if (toggleCursor) {
      document.body.style.cursor = "none";
      cursor.style.display = "block";
    } else {
      document.body.style.cursor = "unset";
      cursor.style.display = "none";
    }
  }
});


const stripe = document.querySelector(".stripe");
const stripe_translate = document.querySelector(".stripe_translate");
const stripe_content = document.querySelector(".stripe .stripe_content");

let scroll = 0
let rafStripe


function startTranslStripe() {
  rafStripe = requestAnimationFrame(updateTranslStripe);
}


let scrollVelocity = 1
let scrollPrev = 0

function updateTranslStripe() {
  const stripeTop = stripe.getBoundingClientRect().top + document.documentElement.scrollTop - document.documentElement.clientHeight

  scrollVelocity = window.pageYOffset - scrollPrev
  scrollPrev = window.pageYOffset

  scroll += scrollVelocity;
  stripe_translate.style.transform = `translateX(${(stripeTop - scroll) / 4}px)`;
  scrollVelocity *= 0.90;
  // console.log("raf", scrollVelocity);
  if (Math.abs(scrollVelocity) > 0.5) {
    rafStripe = requestAnimationFrame(updateTranslStripe);
  }
}


function initStripe() {
  // console.log("init");
  const widthDiv = stripe.clientWidth
  const widthChild = stripe_content.clientWidth

  let nbChilds = 1

  while (widthChild * nbChilds < widthDiv) {
    nbChilds += nbChilds
  }

  for (let i = 0; i < nbChilds * 1; i++) {
    const clone = stripe_content.cloneNode(true)
    stripe_translate.children[0].appendChild(clone)
  }

  interface_count = interface_count + 1;

  if (interface_count >= interfaces.length) {
    interface_container.classList.add("end");
    return;
  }

  interface_container.children[1].style.opacity = "0%";
  interface_container.children[0].src = interfaces[interface_count];
  interface_transition = true;
  setTimeout(() => {
    interface_container.children[1].src = interfaces[interface_count];
    interface_container.children[1].style.opacity = "100%";
    interface_transition = false;
  }, 300);
};

replay.addEventListener("click", () => {
  console.log("exit");
  interface_reset = true;
  resetInterface();
});

resetInterface();
